import React, { useEffect, useState } from "react";
import Checkbox from "./ds/Checkbox";
import Button from "./ds/Button";
import Icon from "./ds/Icon";
import Message from "./ds/Message";
import Modal from "./ds/Modal";
import Options from "./ds/Options";
import Overlay from "./ds/Overlay";
import Textfield from "./ds/Textfield";
import { partialSelect } from "../modules/table";
import { tagState } from "../constants";
import TagRelations from './TagRelations';

const tagStateToIcon = {
  [tagState.pending]: "clock",
  [tagState.approved]: "success",
  [tagState.rejected]: "warning",
};

const tagStateToText = {
  [tagState.pending]: "Pendiente de aprobación",
  [tagState.approved]: "Aprobada",
  [tagState.rejected]: "Rechazada",
};

export default function RowTag({
  tag,
  loading,
  onUpdate,
  onApprove,
  onReject,
  onDelete,
}) {
  const [options, setOptions] = useState(false);
  const [edit, setEdit] = useState(false);
  const [relate, setRelate] = useState(false);
  const [remove, setRemove] = useState(false);
  const [title, setTitle] = useState(tag.title);

  useEffect(() => {
    setTitle(tag.title);
  }, [tag.title]);

  // Options
  useEffect(() => {
    document.body.addEventListener('click', () => setOptions(false));
  }, []);

  function showOptions() {
    setTimeout(() => {
      setOptions(true);
    }, 1);
  }


  return (
    <>
      <div className="row">
        <div className="col-6">
          <Checkbox onchange={partialSelect} />
          <p>{tag.title}</p>
        </div>

        <div className="col-3">
          <Icon icon={tagStateToIcon[tag.state]} />
          <p>{tagStateToText[tag.state]}</p>
        </div>

        <div className="col-3">
          <div className="options">
            <button onClick={showOptions}>
              <Icon icon="options" />
            </button>

            {options && (
              <div>
                <Options>
                  {tag.state === tagState.pending && (
                    <>
                      <li onClick={() => onApprove(tag.id)}><Icon icon="success" />Aprobar</li>
                      <li onClick={() => onReject(tag.id)}><Icon icon="warning" />Rechazar</li>
                      <li onClick={() => setEdit(true)}><Icon icon="pencil" />Editar</li>
                    </>
                  )}
                  {tag.state === tagState.approved && (
                    <li onClick={() => setRelate(true)}><Icon icon="link" />Relacionar</li>
                  )}
                  <li onClick={() => setRemove(true)}><Icon icon="trash" />Eliminar</li>
                </Options>
              </div>
            )}
          </div>
        </div>
      </div>

      {edit && (
        <Overlay>
          <Modal title="Editar tag" onclose={() => setEdit(false)}>
            <div id="edit-tag">
              <Textfield value={title} onChange={e => setTitle(e.target.value)} />
            </div>

            <Button
              label="Actualizar"
              loading={loading}
              onclick={async () => {
                await onUpdate({ ...tag, title, });
                setEdit(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {relate && (
        <Overlay>
          <Modal title="Relacionar tag" onclose={() => setRelate(false)}>
            <TagRelations tag={tag} />
          </Modal>
        </Overlay>
      )}

      {remove && (
        <Overlay>
          <Modal title="Eliminar tag" onclose={() => setRemove(false)}>
            <Message type="warning" description={`Seguro que quieres eliminar el tag "${tag.title}"? Esta acción no se puede deshacer.`} />

            <Button
              type="destructive"
              label="Eliminar"
              onclick={() => onDelete(tag.id)}
            />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
